import React from 'react'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import LinkButton from 'srcReact/components/common2/LinkButton'

function EmptyCard({
  contentTitle,
  contentText,
  contentImage,
  contentButtonLink,
  contentButtonAction,
  contentButton,
  isInnerBox,
  className,
  buttonStyle,
  linkTarget
}) {
  const handleLink = (link) => {
    window.location = link
  }
  return (
    <div className={`${isInnerBox ? '' : styles.card} ${styles.emptyCard} ${className}`}>
      {contentImage && (
        <div className={styles.image}>
          <img src={`${config.assetUrl}/images/${contentImage}.svg`} alt={contentImage} />
        </div>
      )}
      {contentTitle && <h3 className={styles.title}>{contentTitle}</h3>}
      {contentText && <p className={styles.text}>{contentText}</p>}
      {contentButton && (
        <div className={styles.controllers}>
          {contentButtonLink ? (
            <LinkButton
              target={linkTarget}
              style='orange'
              customStyle={buttonStyle}
              href={contentButtonLink}
              text={contentButton}
            />
          ) : contentButtonAction ? (
            <Button style='orange' customStyle={buttonStyle} handleClick={contentButtonAction} text={contentButton} />
          ) : null}
        </div>
      )}
    </div>
  )
}

export default EmptyCard
